import { colors } from '@lmc/common/constants'
import * as React from 'react'
import IconType from '../../../general/Icon/iconTypes'
import ModuleCard from './ModuleCard'

export const GroupPlanModuleCard = () => (
  <ModuleCard
    backgroundColor={colors.purple}
    icon={IconType.GroupsHexagon}
    link="/"
    linkText="Find out more"
    subtitle="Monitor care delivery and performance across multiple sites."
    title="Group Plan"
    onClick={() =>
      window.open(
        'https://support.logmycare.co.uk/en/collections/2248853-the-group-plan'
      )
    }
  />
)
